// Tipos/labels do histórico durável das solicitações de leilão (tabela
// `leilao_solicitacao_historico` do backend) — o que sobrevive ao expurgo do
// Redis, incluindo leilões perdidos e os que não disputamos (NO_BID).
// Espelha `ListSolicitacaoHistoricoResponseDto` do backend `consignado-trabalhador`.

import {
  REDIS_SOLICITACAO_STATUSES,
  REDIS_STATUS_COLORS,
  REDIS_STATUS_LABELS,
  RedisSolicitacaoStatus,
} from "./auction-redis.model";

/**
 * Marcador exclusivo do histórico para solicitações em que NÃO demos lance —
 * não pertence à máquina de status do Redis.
 */
export const NO_BID_STATUS = "LEILAO_SEM_LANCE" as const;

export type HistoricoSolicitacaoStatus =
  | RedisSolicitacaoStatus
  | typeof NO_BID_STATUS;

export const HISTORICO_SOLICITACAO_STATUSES: HistoricoSolicitacaoStatus[] = [
  ...REDIS_SOLICITACAO_STATUSES,
  NO_BID_STATUS,
];

export const HISTORICO_STATUS_LABELS: Record<HistoricoSolicitacaoStatus, string> = {
  ...REDIS_STATUS_LABELS,
  [NO_BID_STATUS]: "Sem lance",
};

export const HISTORICO_STATUS_COLORS: Record<HistoricoSolicitacaoStatus, string> = {
  ...REDIS_STATUS_COLORS,
  [NO_BID_STATUS]: "gray",
};

// Espelha a entity do back, menos o `snapshot` (excluído da listagem). Os
// campos são anuláveis porque a tabela recebe upsert parcial em cada caminho
// de escrita (com lance vs. NO_BID).
export interface HistoricoSolicitacaoItem {
  numeroSolicitacao: number;
  codigoSolicitacaoLeilao: string | null;
  codigoLote: string | null;
  cpf: string | null;
  matricula: string | null;
  nomeTrabalhador: string | null;
  dataNascimento: string | null;
  dataAdmissao: string | null;
  pessoaExpostaPoliticamenteCodigo: number | null;
  pessoaExpostaPoliticamenteDescricao: string | null;
  inscricaoEmpregadorCodigo: number | null;
  inscricaoEmpregadorDescricao: string | null;
  numeroInscricaoEmpregador: string | null;
  valorLiberadoSolicitado: number | null;
  nroParcelasSolicitado: number | null;
  margemDisponivel: number | null;
  elegivelEmprestimo: boolean | null;
  dataHoraValidadeSolicitacao: string | null;
  alertas: unknown[] | null;
  status: HistoricoSolicitacaoStatus;
  ganhou: boolean;
  idProposta: string | null;
  codigoRequisicao: string | null;
  valorTaxaMensal: number | null;
  processorId: string | null;
  dataHoraInicioLeilao: string | null;
  dataHoraFimLeilao: string | null;
  codigoLanceLeilao: string | null;
  lanceTaxaMensal: number | null;
  lanceValorLiberado: number | null;
  lanceNumeroParcelas: number | null;
  posicaoFinal: number | null;
  taxaVencedora: number | null;
  lanceDataHoraInclusao: string | null;
  criadoEmRedis: string | null;
  atualizadoEmRedis: string | null;
  createdAt: string;
  updatedAt: string;
}

// Resposta paginada (snake_case espelha o wire do backend).
export interface HistoricoSolicitacaoListResponse {
  data: HistoricoSolicitacaoItem[];
  total: number;
  pagina_atual: number;
  tamanho_pagina: number;
  total_paginas: number;
  pagina_anterior: number | null;
  proxima_pagina: number | null;
}

export interface HistoricoSolicitacaoListParams {
  page: number;
  pageSize: number;
  searchTerm?: string;
  statuses?: HistoricoSolicitacaoStatus[];
  codigoLote?: string;
}

export interface HistoricoSolicitacaoFilters {
  searchTerm: string;
  statuses: HistoricoSolicitacaoStatus[];
  codigoLote: string;
}

export const INITIAL_HISTORICO_FILTERS: HistoricoSolicitacaoFilters = {
  searchTerm: "",
  statuses: [],
  codigoLote: "",
};
